import React from "react";

/**
 * PopupForm Component - Modal/Dialog đơn giản để hiển thị form
 * 
 * Props:
 * - isShowForm: Boolean - Hiển thị/Ẩn modal
 * - setIsShowForm: Function - Callback để đóng modal
 * - title: String - Tiêu đề modal
 * - position: String - Vị trí modal (mặc định: center)
 * - children: ReactNode - Nội dung bên trong modal
 */
const PopupForm = ({
  isShowForm,
  setIsShowForm,
  title = "",
  position = "center",
  children,
}) => {
  if (!isShowForm) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setIsShowForm(false);
    }
  };

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className={`popup-content popup-${position}`}>
        {/* Header */}
        <div className="popup-header">
          <h3 className="popup-title">{title}</h3>
          <button
            className="popup-close-btn"
            onClick={() => setIsShowForm(false)}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="popup-body">{children}</div>
      </div>

      {/* Styles */}
      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.75);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          padding: 20px;
          overflow-y: auto;
        }

        .popup-content {
          background: #1e293b;
          border-radius: 16px;
          width: 100%;
          max-width: 800px;
          max-height: 90vh;
          overflow-y: auto;
          border: 1px solid #334155;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          animation: slideUp 0.3s ease-out;
        }

        .popup-content.popup-start {
          align-self: flex-start;
        }

        .popup-content.popup-end {
          align-self: flex-end;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 24px;
          border-bottom: 1px solid #334155;
          position: sticky;
          top: 0;
          background: #1e293b;
          z-index: 10;
        }

        .popup-title {
          color: #f1f5f9;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0;
        }

        .popup-close-btn {
          background: transparent;
          border: none;
          color: #cbd5e1;
          font-size: 28px;
          cursor: pointer;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          transition: all 0.2s ease;
        }

        .popup-close-btn:hover {
          background: #334155;
          color: #ef4444;
        }

        .popup-body {
          padding: 24px;
          color: #f1f5f9;
        }

        /* Scrollbar Styles */
        .popup-content::-webkit-scrollbar {
          width: 8px;
        }

        .popup-content::-webkit-scrollbar-track {
          background: #1e293b;
        }

        .popup-content::-webkit-scrollbar-thumb {
          background: #475569;
          border-radius: 4px;
        }

        .popup-content::-webkit-scrollbar-thumb:hover {
          background: #64748b;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .popup-overlay {
            padding: 10px;
          }

          .popup-content {
            max-width: 100%;
            max-height: 95vh;
            border-radius: 12px;
          }

          .popup-header {
            padding: 16px;
          }

          .popup-title {
            font-size: 1.25rem;
          }

          .popup-body {
            padding: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default PopupForm;

